import * as React from 'react';
import cn from 'classnames';
import { Link } from 'react-router-dom';

import {
  CommonIconProps,
  iconSideSizes,
  IconSize
} from 'shared/entities/components/Icon';
import { ComponentType } from 'shared/entities/components/Component';
import { noop } from 'shared/entities/common/utils';

import styles from './BaseIcon.modules.scss';

type Props = CommonIconProps & {
  children?: React.ReactNode;
  /** соотношение ширина / высота */
  proportion?: number;
};

const BaseIcon: React.FC<Props> = (props: Props) => {
  const {
    iconSize = IconSize.M,
    className,
    children,
    svgProps = {},
    iconStyle,
    proportion
  } = props;

  const sideSize = iconSideSizes[iconSize];
  const widthSize = proportion ? Math.ceil(sideSize * proportion) : sideSize;

  if (!props.action) {
    return (
      <svg
        className={cn(iconStyle && styles[`base-icon_${iconStyle}`], className)}
        width={widthSize}
        height={sideSize}
        viewBox={`0 0 ${widthSize} ${sideSize}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...svgProps}
      >
        {children}
      </svg>
    );
  }

  if (props.action.type === ComponentType.link) {
    return (
      <Link
        styleName="base-icon"
        to={props.action.to}
        target={props.action.target}
        className={className}
      >
        <svg
          className={cn(iconStyle && styles[`base-icon_${iconStyle}`])}
          width={widthSize}
          height={sideSize}
          viewBox={`0 0 ${widthSize} ${sideSize}`}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...svgProps}
        >
          {children}
        </svg>
      </Link>
    );
  }

  if (props.action.type === ComponentType.a) {
    return (
      <a
        styleName="base-icon"
        href={props.action.href}
        target={props.action.target}
        className={className}
        onClick={props.action.onClick}
      >
        <svg
          className={cn(iconStyle && styles[`base-icon_${iconStyle}`])}
          width={widthSize}
          height={sideSize}
          viewBox={`0 0 ${widthSize} ${sideSize}`}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...svgProps}
        >
          {children}
        </svg>
      </a>
    );
  }

  return (
    <svg
      onClick={
        props.action.type === ComponentType.svg ? props.action.onClick : noop
      }
      className={cn(iconStyle && styles[`base-icon_${iconStyle}`], className)}
      width={widthSize}
      height={sideSize}
      viewBox={`0 0 ${widthSize} ${sideSize}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      {children}
    </svg>
  );
};

export default React.memo<Props>(BaseIcon);
